import { useCallback } from 'react';

import { generateUIAvatarURL } from 'codekit';
import { readableColor } from 'polished';

import { useTheme } from 'contexts/ThemeContext';

export function useAvatar() {
	// Hooks
	const theme = useTheme();

	// Callbacks
	const generate = useCallback(
		(name: string = '') => {
			return generateUIAvatarURL(name, {
				background: theme.colors.foreground,
				color: readableColor(theme.colors.foreground),
				size: 250,
			});
		},
		[theme.colors.foreground],
	);

	return {
		generate,
	};
}
